/**
 * Functions related to dates and time
 */

/**
 * Formats the date in human readable way
 * @param someDateTimeStamp
 * @returns {string}
 */
export function formatDate(someDateTimeStamp) {
    let fulldays = ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"];
    let months = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];
    let dt = new Date(someDateTimeStamp),
        date = dt.getDate(),
        month = months[dt.getMonth()],
        //timeDiff = someDateTimeStamp - Date.now(),
        diffDays = new Date().getDate() - date,
        diffMonths = new Date().getMonth() - dt.getMonth(),
        diffYears = new Date().getFullYear() - dt.getFullYear();

    if (diffYears === 0 && diffDays === 0 && diffMonths === 0) {
        return "Vandaag";
    } else if (diffYears === 0 && diffDays === 1) {
        return "Gisteren";
    } else if (diffYears === 0 && diffDays === 2) {
        return "Eergisteren";
    } else if (diffYears === 0 && (diffDays > 2 && diffDays < 7)) {
        return fulldays[dt.getDay()];
    } else if (diffYears >= 1) {
        return date + " " + month + ", " + new Date(someDateTimeStamp).getFullYear();
    } else {
        return date + " " + month;
    }
}

/**
 * Convert time parts in a human readable way
 * @param time_parts
 * @returns {string}
 */
export function convertTimeToFullDescription(time_parts) {

    let output = '';

    if (Number(time_parts[0]) === 1) {
        output += time_parts[0] + ' uur';
    } else if (Number(time_parts[0]) > 1) {
        output += time_parts[0] + ' uur';
    }

    if (Number(time_parts[0]) >= 1 && Number(time_parts[1]) >= 1) {
        output += ' en ';
    }

    if (Number(time_parts[1]) === 1) {
        output += time_parts[1] + ' minuut';
    } else if (Number(time_parts[1]) > 1) {
        output += time_parts[1] + ' minuten';
    }

    return output;
}